import script from "./CostAccountingDetail.vue?vue&type=script&lang=ts&setup=true"
export * from "./CostAccountingDetail.vue?vue&type=script&lang=ts&setup=true"

import "./CostAccountingDetail.vue?vue&type=style&index=0&id=7cea68e4&scoped=true&lang=scss"

import exportComponent from "/var/jenkins_home/workspace/oa-sales-user/oa-admin-web/sales-web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7cea68e4"]])

export default __exports__